const navHeaderToggle = document.querySelector('#nav_header__toggle');
const navHeaderRow = document.querySelector('#nav_header__row__button');

if (navHeaderToggle && navHeaderRow) {
  navHeaderToggle.addEventListener('click', () => {
    const isOpen = navHeaderToggle.classList.toggle('open');

    navHeaderRow.classList.toggle('open', isOpen);
    navHeaderToggle.setAttribute('aria-expanded', String(isOpen));
  });
}

const BUTTON_MEDIA_IMAGE_BLUR_START = 10;
const BUTTON_MEDIA_IMAGE_BLUR_END = 50;
const BUTTON_MEDIA_IMAGE_BLUR_MAX = 10;
const ENABLE_BUTTON_MEDIA_IMAGE_EFFECTS = false;

const clearButtonMediaImageEffect = (container) => {
  container.classList.remove(
    'button--media--image--enhanced',
    'button--media--image--landscape',
    'button--media--image--portrait',
  );
  container.style.removeProperty('--button-media-image-url');
  container.style.removeProperty('--button-media-image-fill-url');
  container.style.removeProperty('--button-media-image-offset-x');
  container.style.removeProperty('--button-media-image-offset-y');
  container.style.removeProperty('--button-media-image-blur');
};

const getButtonMediaImageBlur = (letterboxSize) => {
  if (letterboxSize <= BUTTON_MEDIA_IMAGE_BLUR_START) {
    return 0;
  }

  if (letterboxSize >= BUTTON_MEDIA_IMAGE_BLUR_END) {
    return BUTTON_MEDIA_IMAGE_BLUR_MAX;
  }

  const progress = (letterboxSize - BUTTON_MEDIA_IMAGE_BLUR_START) / (BUTTON_MEDIA_IMAGE_BLUR_END - BUTTON_MEDIA_IMAGE_BLUR_START);

  return progress * BUTTON_MEDIA_IMAGE_BLUR_MAX;
};

const updateButtonMediaImageEffect = (container) => {
  if (!ENABLE_BUTTON_MEDIA_IMAGE_EFFECTS) {
    clearButtonMediaImageEffect(container);
    return;
  }

  const image = container.querySelector('img');
  const imageUrl = image?.currentSrc || image?.src;

  if (!image || !imageUrl) {
    return;
  }

  const containerRect = container.getBoundingClientRect();
  const containerWidth = containerRect.width;
  const containerHeight = containerRect.height;

  if (containerWidth <= 0 || containerHeight <= 0) {
    return;
  }

  const widthScale = containerWidth / image.naturalWidth;
  const heightScale = containerHeight / image.naturalHeight;
  const containScale = Math.min(widthScale, heightScale);
  const renderedWidth = image.naturalWidth * containScale;
  const renderedHeight = image.naturalHeight * containScale;
  const offsetX = Math.max(0, (containerWidth - renderedWidth) * 0.5);
  const offsetY = Math.max(0, (containerHeight - renderedHeight) * 0.5);
  const hasSideLetterboxing = offsetX > offsetY;
  const activeLetterboxSize = hasSideLetterboxing ? offsetX : offsetY;
  const blurAmount = getButtonMediaImageBlur(activeLetterboxSize);

  container.style.setProperty('--button-media-image-url', `url("${imageUrl}")`);
  container.style.setProperty('--button-media-image-fill-url', `url("${imageUrl}")`);
  container.style.setProperty('--button-media-image-offset-x', `${offsetX}px`);
  container.style.setProperty('--button-media-image-offset-y', `${offsetY}px`);
  container.style.setProperty('--button-media-image-blur', `${blurAmount}px`);
  container.classList.add('button--media--image--enhanced');
  container.classList.toggle('button--media--image--landscape', !hasSideLetterboxing);
  container.classList.toggle('button--media--image--portrait', hasSideLetterboxing);
};

const getButtonMediaImages = () => document.querySelectorAll('.button--media--image');

const refreshButtonMediaImageEffects = () => {
  getButtonMediaImages().forEach((container) => {
    if (!ENABLE_BUTTON_MEDIA_IMAGE_EFFECTS) {
      clearButtonMediaImageEffect(container);
      return;
    }

    const image = container.querySelector('img');

    if (!image || !(image.complete && image.naturalWidth > 0 && image.naturalHeight > 0)) {
      return;
    }

    updateButtonMediaImageEffect(container);
  });
};

const initializeButtonMediaImageEffects = () => {
  getButtonMediaImages().forEach((container) => {
    if (!ENABLE_BUTTON_MEDIA_IMAGE_EFFECTS) {
      clearButtonMediaImageEffect(container);
      return;
    }

    const image = container.querySelector('img');

    if (!image) {
      return;
    }

    if (image.complete && image.naturalWidth > 0 && image.naturalHeight > 0) {
      updateButtonMediaImageEffect(container);
      return;
    }

    image.addEventListener('load', () => {
      updateButtonMediaImageEffect(container);
    }, { once: true });
  });
};

initializeButtonMediaImageEffects();
window.addEventListener('resize', refreshButtonMediaImageEffects);
window.refreshButtonMediaImageEffects = refreshButtonMediaImageEffects;
